import script from "./voiceMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./voiceMessage.vue?vue&type=script&setup=true&lang=ts"

import "./voiceMessage.vue?vue&type=style&index=0&id=4469eee0&lang=css"

const __exports__ = script;

export default __exports__